import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ConfigForm from './components/ConfigForm';

const Config = (props) => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Configurações</h3>
          <h3 className="page-subhead subhead">
            Atenção ao alterar as configurações do site!{' '}
            <strong>As alterações passam a valer imediatamente!!</strong>
          </h3>
        </Col>
      </Row>
      <Row>
        <ConfigForm isHorizontal isAboveError props={props} />
      </Row>
    </Container>
  );
};

export default Config;
